// extracted by mini-css-extract-plugin
export default {"validation":"ResetPasswordForm_validation__+1it3"};